import { ColumnDef } from "@tanstack/react-table";

import { icons } from "~/ui/common/Icons";
import { CompactTable } from "~/ui/table/CompactTable";
import { formatPatientId, type PatientIdRow } from "../utils/patient-id";

const EMPTY_VALUE = "-";

const columns: ColumnDef<PatientIdRow>[] = [
  {
    header: "Athena ID",
    id: "patientId",
    cell: ({ row }) => {
      const { patientId, isPrimary } = row.original;

      if (!patientId) {
        return <span className="text-neutral-500">Pending</span>;
      }

      return (
        <span className="font-medium">
          {formatPatientId(patientId, isPrimary)}
        </span>
      );
    },
  },
  {
    header: "Provider group",
    id: "providerGroup",
    cell: ({ row }) => row.original.providerGroup?.name ?? EMPTY_VALUE,
  },
  {
    header: "Department",
    id: "states",
    cell: ({ row }) => row.original.states.join(", ") || EMPTY_VALUE,
  },
];

export const PatientRegistrationTable = ({
  rows,
}: {
  rows: PatientIdRow[];
}) => {
  const rowsWithId = rows.filter((row) => row.patientId);
  const showEnterpriseNote =
    rowsWithId.length > 1 && rowsWithId.some((row) => row.isPrimary);

  return (
    <div className="flex flex-col gap-3">
      <CompactTable
        data={rows}
        columns={columns}
        variant="plain"
        emptyState="No patient ID on file"
      />
      {showEnterpriseNote && (
        <p className="flex items-center gap-2 text-sm text-neutral-600">
          <icons.outline.InformationCircleIcon className="size-5 shrink-0" />
          The Enterprise ID is the first patient ID created.
        </p>
      )}
    </div>
  );
};
